var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'main-navbar d-md-none d-lg-none',
    'bg-white',
    _vm.stickyTop ? 'sticky-top' : '',
  ]},[_c('d-navbar',{staticClass:"align-items-stretch flex-md-nowrap p-0",attrs:{"type":"light"}},[_c('navbar-nav'),_c('navbar-toggle')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }